import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { alpha, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    color: alpha(theme.palette.error.main, 0.85),
    "&:hover": {
      color: theme.palette.error.main,
      backgroundColor: "transparent",
    },
    "&:focus-visible": {
      color: theme.palette.error.main,
    },
  },
}));

const ErrorTooltipIcon = ({ message, placement = "top", ...props }) => {
  const classes = useStyles();
  const isDesktopPointer = useMediaQuery("(hover: hover) and (pointer: fine)");

  if (!message || !isDesktopPointer) return null;

  return (
    <Tooltip title={message} placement={placement} arrow>
      <IconButton aria-label={message} size="small" className={classes.iconButton} {...props}>
        <ErrorOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default ErrorTooltipIcon;
